//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.TurningToolBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"HolderGrooveHand",1,0],[0,"HolderHand",1,0],[1,"HolderInsertExtensionBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"HolderStyle",1,0],[0,"InsertShape",1,0],[1,"LeftRadiusBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"RadiusBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"RightRadiusBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"SideAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TipAngleBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.GrooveToolBuilder = class extends SPLM.CAM.TurningToolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GrooveToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GrooveToolBuilder.InsertShapes = Object.freeze({
    "Std" : "Std", "Fnr" : "Fnr", "Rtj" : "Rtj", "User" : "User"});

SPLM.CAM.GrooveToolBuilder.HolderStyles = Object.freeze({
    "Deg0" : "Deg0", "Deg45" : "Deg45", "Deg90" : "Deg90", "UserDefined" : "UserDefined"});

SPLM.CAM.GrooveToolBuilder.HolderHands = Object.freeze({
    "Left0" : "Left0", "Left90" : "Left90", "Right0" : "Right0", "Right90" : "Right90"});

SPLM.CAM.GrooveToolBuilder.HolderGrooveHands = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;